module.exports = __webpack_public_path__ + "img/Group254.18e09120.png";